export default from './member-list-item';



// WEBPACK FOOTER //
// ./app/components/member-list-item/index.js